'use strict';

export default class ActivateController {

  /*@ngInject*/
  constructor(Auth, $state, $scope, $http, $location, $stateParams) {
    var vm = this;
    vm.activating = false;

    vm.patchPassword = function(){
      vm.activating = true;
      $http.post(`api/users/activateLink/${$stateParams.id}`, {password : vm.password}).then(function (response) {
        console.log(response);
        vm.activating = false;
        if(response.data.error) {
          return vm.errors = response.data;
          $scope.$apply();
        }

        Auth.login({
          email: response.data,
          password: vm.password
        })
        .then(() => {
          $state.go('main');
        })
        .catch(err => {
          $location.path('/');
        });
      }).catch(function(response){
        vm.errors = response.data
        // $location.path('/');
      })
    }
  }
}



// WEBPACK FOOTER //
// ./client/app/account/activate/activate.controller.js